import React, { FC } from "react";

import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tag from "antd/es/tag";
import { defineMessages, useIntl } from "react-intl";

import { GuideStatus } from "@mapmycustomers/shared";

const messages = defineMessages<GuideStatus>({
  [GuideStatus.COMPLETED]: {
    id: "guideStatus.completed",
    defaultMessage: "Done",
    description: "Done guide status title",
  },
  [GuideStatus.NOT_STARTED]: {
    id: "guideStatus.notStarted",
    defaultMessage: "Not Started",
    description: "Not Started guide status title",
  },
  [GuideStatus.PROGRESS]: {
    id: "guideStatus.inProgress",
    defaultMessage: "In Progress",
    description: "In Progress guide status title",
  },
});

export interface GuideStatusProps {
  status: GuideStatus;
}

const GuideStatusTag: FC<GuideStatusProps> = ({ status }) => {
  const intl = useIntl();
  return (
    <Tag color={status === GuideStatus.COMPLETED ? "success" : "default"}>
      {status === GuideStatus.COMPLETED && <FontAwesomeIcon icon={faCheck} />}{" "}
      {intl.formatMessage(messages[status])}
    </Tag>
  );
};

export default GuideStatusTag;
